import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { ENDPOINTS } from '../../../../shared/organizationPackages/helpers';
import type { PackageInventoryQueryParams } from '../../../helpers/packageInventory';
import type { FetchPackagesResponse } from '../../../../shared/organizationPackages/response';

const fetchPackages = (params: PackageInventoryQueryParams) =>
  get<FetchPackagesResponse>(ENDPOINTS.FETCH_PACKAGES, true, params, { encodeQuery: true });

export const getPackagesQueryKey = (params: PackageInventoryQueryParams) => ['packages', 'list', params] as const;

export default function usePackages(params: PackageInventoryQueryParams) {
  return useQuery<FetchPackagesResponse>({
    queryKey: getPackagesQueryKey(params),
    queryFn: () => fetchPackages(params),
    staleTime: 1000 * 60 * 5,
    // eslint-disable-next-line @typescript-eslint/no-deprecated -- React Query v4 option required by this migration.
    keepPreviousData: true,
  });
}
